import { Button, Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import { CircularIconContainer } from "../CircularIconContainer";
import MarkdownRenderer from "../MarkdownRenderer";
import { PurchasedProductCard } from "./PurchasedProductCard";
import { StoreNoteCard } from "./StoreNoteCard";
import type {
	PurchaseSuccessAction,
	PurchaseSuccessProduct,
	PurchaseSuccessStoreNote,
} from "./types";

const SUCCESS_ICON_CONTAINER_SIZE = 72;
const SUCCESS_ICON_SIZE = 40;

type Props = {
	title: string;
	summary?: string;
	products: PurchaseSuccessProduct[];
	appFont?: string;
	storeNote?: PurchaseSuccessStoreNote;
	primaryAction?: PurchaseSuccessAction;
	secondaryAction?: PurchaseSuccessAction;
};

export const PurchaseSuccessApplet = ({
	title,
	summary,
	products,
	appFont,
	storeNote,
	primaryAction,
	secondaryAction,
}: Props) => {
	const theme = useAppTheme();

	return (
		<Box gap={16}>
			<Box gap={12} alignItems="center">
				<CircularIconContainer
					iconName="check-circle"
					size={SUCCESS_ICON_CONTAINER_SIZE}
					iconSize={SUCCESS_ICON_SIZE}
					backgroundColor={theme.colors.surfaceVariant}
					iconColor={theme.palette.success.main}
				/>
				<Text
					variant="titleMedium"
					style={{
						textAlign: "center",
						...(appFont ? { fontFamily: `${appFont}-semibold` } : {}),
					}}
				>
					{title}
				</Text>
				{summary ? (
					<MarkdownRenderer
						text={summary}
						variant="stem"
						textAlign="center"
						appFont={appFont}
					/>
				) : null}
			</Box>
			{products.map((product) => (
				<PurchasedProductCard key={product.id} {...product} appFont={appFont} />
			))}
			{storeNote ? <StoreNoteCard {...storeNote} /> : null}
			{primaryAction || secondaryAction ? (
				<Box gap={8}>
					{primaryAction ? (
						<Button
							mode="contained"
							onPress={primaryAction.onPress}
							loading={primaryAction.loading}
							disabled={primaryAction.loading}
						>
							{primaryAction.label}
						</Button>
					) : null}
					{secondaryAction ? (
						<Button
							onPress={secondaryAction.onPress}
							loading={secondaryAction.loading}
							disabled={secondaryAction.loading}
						>
							{secondaryAction.label}
						</Button>
					) : null}
				</Box>
			) : null}
		</Box>
	);
};
